<template>
  <div class="portal-inicio">
    <div class="inicio-header">
      <p v-if="turmaNome" class="inicio-turma"><i class="el-icon-school"></i> {{ turmaNome }}</p>
      <p class="inicio-sub">Bem-vindo(a) ao Portal do Aluno. Selecione o que deseja acessar.</p>
    </div>

    <el-row :gutter="16" class="inicio-cards" v-if="temAlgumModulo">
      <el-col :xs="24" :sm="12" :md="8" v-if="permissoes.ver_notas || permissoes.ver_parecer">
        <router-link to="/diario" class="card-modulo">
          <i class="el-icon-document card-icone"></i>
          <div class="card-titulo">Diário</div>
          <div class="card-desc">Consulte suas notas, faltas e pareceres por período.</div>
        </router-link>
      </el-col>

      <el-col :xs="24" :sm="12" :md="8" v-if="permissoes.baixar_material">
        <router-link to="/materiais" class="card-modulo">
          <i class="el-icon-folder-opened card-icone"></i>
          <div class="card-titulo">Materiais</div>
          <div class="card-desc">Acesse os materiais publicados pela sua turma.</div>
        </router-link>
      </el-col>

      <el-col :xs="24" :sm="12" :md="8">
        <router-link to="/ocorrencias" class="card-modulo">
          <i class="el-icon-warning-outline card-icone"></i>
          <div class="card-titulo">Ocorrências</div>
          <div class="card-desc">Acompanhe as ocorrências registradas.</div>
        </router-link>
      </el-col>

      <!-- BLOCO L — item 109. Mesma condição do item de menu em layout/index.vue. -->
      <el-col :xs="24" :sm="12" :md="8" v-if="permissoes.ver_acompanhamento">
        <router-link to="/acompanhamentos" class="card-modulo">
          <i class="el-icon-notebook-2 card-icone"></i>
          <div class="card-titulo">Acompanhamento</div>
          <div class="card-desc">Veja os planos e registros que a escola liberou para a família.</div>
        </router-link>
      </el-col>
    </el-row>

    <div v-else class="inicio-vazio">
      <i class="el-icon-warning-outline"></i>
      <p>Nenhum módulo está disponível para o seu perfil no momento.</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Inicio',
  computed: {
    permissoes () { return this.$store.getters.permissoes },
    alunoNome () { return this.$store.state.user.aluno_nome },
    // minúsculas para o CSS text-transform: capitalize renderizar "Amanda Ferreira Oliveira"
    alunoNomeFormatado () { return (this.$store.state.user.aluno_nome || 'aluno(a)').toLowerCase() },
    turmaNome () { return this.$store.state.user.turma_nome },
    temAlgumModulo () {
      // Ocorrências está sempre disponível para o aluno logado.
      return true
    }
  },
  mounted () {
    if (!localStorage.getItem('pa85726549Token')) {
      this.$router.push('/')
    }
  }
}
</script>

<style scoped>
.portal-inicio {
  padding: 30px 16px;
  max-width: 900px;
  margin: 0 auto;
}
.inicio-header {
  text-align: center;
  margin-bottom: 28px;
}
.inicio-header h2 {
  color: #303133;
  font-weight: 600;
  font-size: 28px;
  margin: 0 0 6px;
  text-transform: capitalize;
  word-break: break-word;
}
@media (max-width: 640px) {
  .inicio-header h2 { font-size: 20px; }
}
.inicio-turma {
  color: #409eff;
  font-weight: 600;
  margin: 0 0 4px;
}
.inicio-sub {
  color: #909399;
  font-size: 14px;
  margin: 0;
}
.inicio-cards {
  margin-top: 10px;
}
.card-modulo {
  display: block;
  text-decoration: none;
  background: #fff;
  border: 1px solid #ebeef5;
  border-radius: 10px;
  padding: 26px 20px;
  text-align: center;
  margin-bottom: 16px;
  transition: box-shadow .15s ease, transform .15s ease, border-color .15s ease;
}
.card-modulo:hover {
  box-shadow: 0 6px 18px rgba(0, 0, 0, .08);
  transform: translateY(-2px);
  border-color: #c6e2ff;
}
.card-icone {
  font-size: 40px;
  color: #409eff;
}
.card-titulo {
  font-size: 18px;
  font-weight: 600;
  color: #303133;
  margin-top: 12px;
}
.card-desc {
  font-size: 13px;
  color: #909399;
  margin-top: 6px;
}
.inicio-vazio {
  text-align: center;
  color: #909399;
  padding: 50px 20px;
}
.inicio-vazio i {
  font-size: 42px;
  display: block;
  margin-bottom: 12px;
}
</style>
